import { render, staticRenderFns } from "./ConstructionUserItem.vue?vue&type=template&id=b3c0f882&lang=pug&"
import script from "./ConstructionUserItem.vue?vue&type=script&lang=ts&"
export * from "./ConstructionUserItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionUserItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
